<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-2"> </p>
<p class="TX1 ParaOverride-2"><span class="CharOverride-2">BY THE SAME AUTHOR</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">Village of Stone</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">A Concise Chinese–English Dictionary for Lovers</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">20 Fragments of a Ravenous Youth</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">UFO in Her Eyes</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">Lovers in the Age of Indifference</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">I Am China</span></p>
<p class="TX1 ParaOverride-3"><span class="I _idGenCharOverride-1">Once Upon a Time in the East</span></p>
<p class="TX1 ParaOverride-3"><span class="CharOverride-1">Nine Continents</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021495411.vue?0299133b